/**
 * Application Constants
 * Centralized location for all hardcoded values to improve maintainability
 * Constants that don't change based on environment
 */

import config from './config.js';

// Toast & Notification Durations (milliseconds) - from environment config
export const TOAST_DURATION = config.TOAST_DURATION;
export const ERROR_TOAST_DURATION = config.ERROR_TOAST_DURATION;
export const TOAST_SLIDE_OUT_DELAY = config.TOAST_DURATION - 300; // For CSS animation timing

// Timing & Delays - from environment config
export const MODAL_FOCUS_DELAY = 100;
export const DEBOUNCE_DELAY = config.DEBOUNCE_DELAY;
export const ANIMATION_DURATION = config.ANIMATION_DURATION;

// Error Handling - static across environments
export const MAX_ERROR_COUNT = 10;
export const ERROR_STATS_RECENT_LIMIT = 5;

// UI Dimensions & Layout - static across environments
export const CARD_IMAGE_HEIGHT = 200;
export const MAX_INGREDIENT_DISPLAY = 5;
export const MODAL_Z_INDEX = 10000;
export const ERROR_TOAST_Z_INDEX = 10001;

// Storage Keys - static across environments
export const FAVORITES_STORAGE_KEY = 'cocktail-favorites';

// API & Network - from environment config
export const NETWORK_TIMEOUT = config.NETWORK_TIMEOUT;
export const API_RETRY_ATTEMPTS = config.API_RETRY_ATTEMPTS;
export const API_RETRY_DELAY = 1000; // Static delay between retries

// Responsive Breakpoints (pixels)
export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;
export const DESKTOP_BREAKPOINT = 1200;

// Component State
export const LOADING_STATE = 'loading';
export const ERROR_STATE = 'error';
export const SUCCESS_STATE = 'success';
export const EMPTY_STATE = 'empty';

// SVG Icon Dimensions
export const SMALL_ICON_SIZE = 20;
export const MEDIUM_ICON_SIZE = 22;
export const LARGE_ICON_SIZE = 24;

// Focus Management
export const FOCUSABLE_ELEMENTS_SELECTOR = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

// Event Types
export const COCKTAIL_EVENTS = {
  OPEN_MODAL: 'open-modal',
  COCKTAIL_COPIED: 'cocktail-copied',
  APP_ERROR: 'app-error',
  FAVORITE_TOGGLED: 'favorite-toggled'
};

// Error Types
export const ERROR_TYPES = {
  JAVASCRIPT: 'javascript',
  PROMISE: 'promise',
  NETWORK: 'network',
  API: 'api',
  COMPONENT: 'component',
  APPLICATION: 'application'
};

// Keyboard Keys
export const KEYBOARD_KEYS = {
  ESCAPE: 'Escape',
  TAB: 'Tab',
  ENTER: 'Enter',
  SPACE: ' '
};
